import { TALUKA_LIST, TALUKA_CHANGE_STATUS, TALUKA_ADDEDIT, TALUKA_WOP_LIST, TALUKA_DELETE } from "../../api/constApi";
import { authHeader } from "./authHeader";
import { apiInstance } from "./axiosApi";


export const TalukaListApi = (payload) => {
    return apiInstance.post(TALUKA_LIST, payload, {
        headers: authHeader(),
    });
};

export const TalukaChangeStatusApi = (payload) => {
    return apiInstance.post(TALUKA_CHANGE_STATUS, payload, {
        headers: authHeader(),
    });
};

export const AddEditTalukaApi = (payload) => {
    return apiInstance.post(TALUKA_ADDEDIT, payload, {
        headers: authHeader(),
    });
}; 

export const talukaDeleteApi = (payload) => {
    return apiInstance.post(TALUKA_DELETE, payload, {
        headers: authHeader(),
    });
};

export const TalukaWopListApi = (payload) => {
    return apiInstance.get(TALUKA_WOP_LIST, {
        headers: authHeader(),
        params: payload
    });
};